import { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
import HomePage from "../pages/home";

// Route-level code splitting: each page below ships as its own chunk and loads
// on navigation, cutting the initial JS bundle. Home stays eager (it is the
// landing route / LCP). The <Suspense> wrapper in router/index.js covers these.
const AboutPage = lazy(() => import("../pages/about"));
const ManagementPage = lazy(() => import("../pages/management"));
const ServicesPage = lazy(() => import("../pages/services"));
const PartnershipsPage = lazy(() => import("../pages/partnerships"));
const InitiativesPage = lazy(() => import("../pages/initiatives"));
const EnergyTransitionPage = lazy(() => import("../pages/energyTransition"));
const CodeOfConductPage = lazy(() => import("../pages/codeOfConduct"));
const FAQPage = lazy(() => import("../pages/faq"));
const TermsAndConditionPage = lazy(() => import("../pages/termsAndCondition"));
const PurchaseProcessPage = lazy(() => import("../pages/purchaseProcess"));
const NotFoundPage = lazy(() => import("../pages/notFound"));
const NewsPage = lazy(() => import("../pages/news"));
const NewsDetailsPage = lazy(() => import("../pages/newsDetail"));
const PublicationsPage = lazy(() => import("../pages/publications"));
const PublicationsDetailsPage = lazy(() => import("../pages/publicationsDetail"));
const GalleryPage = lazy(() => import("../pages/gallery"));
const GalleryDetailPage = lazy(() => import("../pages/galleryDetail"));
const TransparencyAndAccountabilityPage = lazy(() =>
  import("../pages/whistleblowerPolicy")
);
const DisclaimerPage = lazy(() => import("../pages/disclaimer"));

const routes = createBrowserRouter([
  {
    path: "/",
    exact: true,
    element: <HomePage />,
  },
  {
    path: "/about",
    exact: true,
    element: <AboutPage />,
  },
  {
    path: "/management",
    exact: true,
    element: <ManagementPage />,
  },
  {
    path: "/code-of-conduct",
    exact: true,
    element: <CodeOfConductPage />,
  },
  {
    path: "/services",
    exact: true,
    element: <ServicesPage />,
  },
  {
    path: "/initiatives",
    exact: true,
    element: <InitiativesPage />,
  },
  {
    path: "/partnerships",
    exact: true,
    element: <PartnershipsPage />,
  },
  {
    path: "/energy-transition",
    exact: true,
    element: <EnergyTransitionPage />,
  },
  {
    path: "/whistleblower-policy",
    exact: true,
    element: <TransparencyAndAccountabilityPage />,
  },
  { path: "/disclaimer", exact: true, element: <DisclaimerPage /> },
  {
    path: "/purchase-process",
    exact: true,
    element: <PurchaseProcessPage />,
  },
  {
    path: "/news",
    exact: true,
    element: <NewsPage />,
  },
  {
    path: "/news/:slug",
    exact: true,
    element: <NewsDetailsPage />,
  },
  {
    path: "/publications",
    exact: true,
    element: <PublicationsPage />,
  },
  {
    path: "/publications/:slug",
    exact: true,
    element: <PublicationsDetailsPage />,
  },
  {
    path: "/gallery",
    exact: true,
    element: <GalleryPage />,
  },
  {
    path: "/gallery/:slug",
    exact: true,
    element: <GalleryDetailPage />,
  },
  // {
  //   path: "/branding",
  //   exact: true,
  //   element: <BrandingPage />,
  // },
  // ..
  {
    path: "/faq",
    exact: true,
    element: <FAQPage />,
  },
  {
    path: "/terms-and-conditions",
    exact: true,
    element: <TermsAndConditionPage />,
  },

  {
    path: "*",
    element: <NotFoundPage />,
  },
]);

export default routes;
